import React from 'react';
import { ChevronRight } from 'lucide-react';

export default function StrategyMapNode({ title, items, kpis, icon, className, iconColor }) {
  const Icon = icon;
  return (
    <div className={`bg-white/70 backdrop-blur-sm h-full p-5 rounded-2xl shadow-lg border border-gray-200/50 transition-all duration-300 hover:shadow-2xl hover:scale-105 flex flex-col ${className || ''}`}>
      <div className="flex-grow">
        <div className="mb-3">
          <div className={`p-2 rounded-lg inline-block ${iconColor}`}>
            <Icon className="w-7 h-7 text-white" />
          </div>
        </div>
        <h3 className="text-lg font-bold text-gray-800 leading-tight mb-3">{title}</h3>
        <ul className="space-y-2 pl-1">
          {items.map((item, index) => (
            <li key={`item-${index}`} className="flex items-start text-sm text-gray-600">
              <ChevronRight size={16} className="mr-2 mt-0.5 flex-shrink-0 text-indigo-400" />
              <span>{item}</span>
            </li>
          ))}
        </ul>
        {kpis && kpis.length > 0 && (
          <div className="mt-4 pt-3 border-t border-gray-200/60">
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">KPIs</p>
            <ul className="space-y-1">
              {kpis.map((kpi, index) => (
                <li key={`kpi-${index}`} className="text-sm font-medium text-indigo-700">{kpi}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}
